import eventEmitter, { types } from './eventEmitter'
import { DOCUMENT_TYPES, TRoles } from './const'

/*
 * Hinweis auf die Anmeldung als Unterstützer:in, wenn eine Schüler:in ihre
 * Teilnahmeurkunde herunterlädt (Anforderung #212).
 *
 * Er gilt nur für Absolvent:innen einer Junior Company (JC) und einer Junior
 * Compact Company (JCC), nicht für die Junior Basic Company (JBC). Dieselbe
 * Einschränkung trägt der Absatz in der Urkunden-Mail (Backend,
 * services/email/supporterInvitation.js) — beide müssen dasselbe sagen.
 *
 * Gezeigt wird das Fenster von `UI/SupporterInvitationDialog`, das einmal in
 * App.js hängt. Es blockiert nichts: Der Download läuft vorher an, das Fenster
 * kommt danach dazu.
 */
export const SUPPORTER_INVITATION_COMPANY_TYPES = ['JC', 'JCC']

export const invitesToSupporterRegistration = companyType => SUPPORTER_INVITATION_COMPANY_TYPES.includes(companyType)

/**
 * Bekommt diese Person beim Herunterladen dieses Dokuments den Hinweis?
 * Nur Schüler:innen, nur die Teilnahmeurkunde, nur JC/JCC.
 */
export const shouldShowSupporterInvitation = ({ role, companyType, documentType }) =>
	role === TRoles.STUDENT &&
	documentType === DOCUMENT_TYPES.PARTICIPATION_DOCUMENT &&
	invitesToSupporterRegistration(companyType)

export function showSupporterInvitation() {
	eventEmitter.emit(types.openSupporterInvitation)
}

/** Nach dem Herunterladen aufrufen; zeigt den Hinweis nur, wo er hingehört. */
export function maybeShowSupporterInvitation(context) {
	if (shouldShowSupporterInvitation(context)) showSupporterInvitation()
}
